{
    "consentModal": {
        "title": "Cookie time!",
        "description": "<div>We and our partners use cookies and process data. Some cookies and data processings are mandatory for technical reasons. Others help us to provide functionality to our website.</div><br /><div><em>Reject all</em> prevents these but some functionality of the website (like the contact form) may be unavailable.</div><br /><div>With <em>Accept all</em> you agree to the processing of data and identifications or IP addresses of your device for data processing purposes according to § 25 Abs. 1 TDDDG as well as Art. 6 Abs. 1 lit. a DSGVO. Additionally you agree to data processing by service providers in the US according to Art. 49 Abs. 1 DSGVO. In this case it is possible that the transferred data is also processed by local authorities.</div><br /><div>Clicking <em>Manage settings</em> allows you to consent to individual connections and to find additional details.</div>",
        "acceptAllBtn": "Accept all",
        "acceptNecessaryBtn": "Reject all",
        "showPreferencesBtn": "Manage settings",
        "footer": "<a href=\"pages/datenschutz.html\">Privacy Policy</a>"
    },
    "preferencesModal": {
        "title": "Privacy Settings",
        "acceptAllBtn": "Accept all",
        "acceptNecessaryBtn": "Reject all",
        "savePreferencesBtn": "Save settings",
        "closeIconLabel": "Close",
        "sections": [
            {
                "title": "Use of cookies and your data",
                "description": "We use cookies to provide basic functionality on our website and in order to improve our service."
            },
            {
                "title": "Necessary Cookies",
                "description": "These cookies are essential for the proper functioning of the website, for example for storing your choices here.",
                "linkedCategory": "necessary",
                "cookieTable": {
                    "headers": {
                        "name": "Name",
                        "domain": "Service",
                        "description": "Description",
                        "expiration": "Expiration"
                    },
                    "body": [
                        {
                            "name": "cc_cookie",
                            "domain": "skinfactory.tattoo",
                            "description": "Your privacy choices on this screen are saved there.",
                            "expiration": "6 Monate"
                        }
                    ]
                }
            },
            {
                "title": "Functionality Cookies",
                "description": "These cookies allow us to provide provide useful functionality to you and to include content from other websites.",
                "linkedCategory": "functionality",
                "cookieTable": {
                    "headers": {
                        "name": "Name",
                        "domain": "Service",
                        "description": "Description",
                        "expiration": "Expiration"
                    },
                    "body": [
                        {
                            "name": "elfsight_viewed_recently",
                            "domain": "elfsight.com",
                            "description": "We use Elfsight for our contact form, our Instagram Feed and to show Google Reviews. This cookie helps to prevent fast repeated form submissions.",
                            "expiration": "Expires alle 15 Sekunden"
                        },
                    ]
                }
            },
            {
                "title": "Further information",
                "description": "Please contact us in case you have any questions regarding our data processing or use of cookies."
            }
        ]
    }
}
